import type { StripeSubscriptionSummary } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

const useGetSubscription = requestBuilder.query<
    StripeSubscriptionSummary | null,
    { userId: string }
>({
    endpoint: () => '/api/billing/subscription',
    queryKey: ({ userId }) => `getSubscription/${userId}`,
});

export default useGetSubscription;
